<template>
    <bar-default v-if="defaultBar"></bar-default>
    <bar-account v-else-if="accountBar"></bar-account>
    <bar-profile v-else-if="userBar"></bar-profile>
    <bar-explore v-else-if="exploreBar"></bar-explore>
    <bar-search v-else-if="searchBar"></bar-search>
    <bar-post v-else-if="postBar"></bar-post>
    <bar-generic v-else-if="genericBar" :toolbarTitle="genericBarTitle"></bar-generic>
</template>
<script>
import barDefault from "./bar-app-mobile-default.vue"
import barAccount from "./bar-app-mobile-account.vue"
import barProfile from "./bar-app-mobile-profile.vue"
import barExplore from "./bar-app-mobile-explore.vue"
import barSearch from "./bar-app-mobile-search.vue"
import barGeneric from "./bar-app-mobile-generic.vue"
import barPost from "./bar-app-mobile-post.vue"
export default {
    components: {
        'bar-default': barDefault,
        'bar-profile': barProfile,
        'bar-explore': barExplore,
        'bar-search': barSearch,
        'bar-generic': barGeneric,
        'bar-post': barPost,
        barAccount
    },
    computed: {
        defaultBar() {
            return !this.userBar && !this.exploreBar && !this.searchBar && !this.genericBar && !this.postBar && !this.accountBar
        },

        userBar() {
            return this.$route.matched.some(record => record.meta.userTopbar)
        },

        accountBar() {
            return this.$route.matched.some(record => record.meta.accountTopbar)
        },

        exploreBar() {
            return this.$route.matched.some(record => record.meta.exploreTopbar)
        },

        searchBar() {
            return this.$route.matched.some(record => record.meta.searchTopbar)
        },

        genericBar() {
            return this.$route.matched.some(record => record.meta.genericMobilebar)
        },

        postBar() {
            return this.$route.matched.some(record => record.meta.postMobilebar)
        },

        genericBarTitle() {
            let title = this.$route.meta.genericMobilebarTitle || null
            return title
        }
    }
}
</script>